// extracted by mini-css-extract-plugin
module.exports = {"titleChart":"ProfitLineChart_titleChart__qD2iv","radioFilterButton":"ProfitLineChart_radioFilterButton__2h_8p"};